module.exports = __webpack_public_path__ + "img/douyinicon.d3471974.png";